import IconEmail from 'assets/icons/email.svg';
import { useSubscriptionDetailsState } from 'modules/account/pages/subscription/state';
import { useSubscriptionFunnel } from 'modules/subscription-funnel/state';
import React from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';

const SubsDeliveyInfo: React.FC = () => {
  const { subscriptionId } = useSubscriptionFunnel();
  const id = subscriptionId;

  const { shippingAddress, subscription } = useSubscriptionDetailsState({
    id,
  });

  return (
    <div>
      <div className="text-primary-main mt-4 flex text-lg font-medium">
        <IconEmail className="mt-1 mr-2 h-4 w-8" />
        <FormattedMessage id="subscription-funnel:overview:delivery-address" />
      </div>
      {shippingAddress && (
        <p className="mt-2 mb-4">
          {shippingAddress.address1}, {shippingAddress.zip}, {shippingAddress.city}
        </p>
      )}
      <FormattedMessage
        id="subscription-funnel:overview:delivery-date"
        values={{
          dateStr: (
            <span className="font-black">
              <FormattedDate
                day="2-digit"
                month="long"
                year="numeric"
                value={subscription?.periodEndAt}
              />
            </span>
          ),
        }}
      />
    </div>
  );
};

export default SubsDeliveyInfo;
